import React, { useEffect } from 'react';
import { insertCss } from 'insert-css';
import warn from '../_util/warning';
import generateColor from './generate';
export function warning(valid, message) {
    warn(valid, `[@c7n/icons] ${message}`);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isIconDefinition(target) {
    return (typeof target === 'object' &&
        typeof target.name === 'string' &&
        typeof target.theme === 'string' &&
        (typeof target.icon === 'object' || typeof target.icon === 'function'));
}
export function normalizeAttrs(attrs = {}) {
    return Object.keys(attrs).reduce((acc, key) => {
        const val = attrs[key];
        switch (key) {
            case 'class':
                acc.className = val;
                delete acc.class;
                break;
            default:
                acc[key] = val;
        }
        return acc;
    }, {});
}
export function generate(node, key, rootProps) {
    if (!rootProps) {
        return React.createElement(node.tag, { key, ...normalizeAttrs(node.attrs) }, (node.children || []).map((child, index) => generate(child, `${key}-${node.tag}-${index}`)));
    }
    return React.createElement(node.tag, {
        key,
        ...normalizeAttrs(node.attrs),
        ...rootProps,
    }, (node.children || []).map((child, index) => generate(child, `${key}-${node.tag}-${index}`)));
}
export function getSecondaryColor(primaryColor) {
    // choose the second color
    return generateColor(primaryColor)[0];
}
export function normalizeTwoToneColors(twoToneColor) {
    if (!twoToneColor) {
        return [];
    }
    return Array.isArray(twoToneColor) ? twoToneColor : [twoToneColor];
}
// These props make sure that the SVG behaviours like general text.
// Reference: https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
export const svgBaseProps = {
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true',
    focusable: 'false',
};
export const iconStyles = `
.c7nicon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.c7nicon > * {
  line-height: 1;
}

.c7nicon svg {
  display: inline-block;
}

.c7nicon::before {
  display: none;
}

.c7nicon .c7nicon-icon {
  display: block;
}

.c7nicon[tabindex] {
  cursor: pointer;
}

.c7nicon-spin::before,
.c7nicon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`;
let cssInjectedFlag = false;
export const useInsertStyles = (styleStr = iconStyles) => {
    useEffect(() => {
        if (!cssInjectedFlag) {
            insertCss(styleStr, {
                prepend: true,
            });
            cssInjectedFlag = true;
        }
    }, []);
};
